import React from "react"
import { navigate } from "gatsby"
// import { render } from "react-dom"

const IndexPage = () => {
  if (typeof window !== "undefined") {
    navigate("/czego-boja-sie-frankowicze")
  }

  return <></>
}

export default IndexPage
